export default function ForbiddenPage() {
  return <h1>Access Denied</h1>;
}
